import { useMemoDebounced } from "./useMemoDebounced.js";
import { useState } from "react";
// src/hooks/useStateDebounced.ts
function useStateDebounced(initState, delay = 500) {
	const [state, setState] = useState(initState);
	return [
		state,
		useMemoDebounced(() => state, [state], delay),
		setState
	];
}
export { useStateDebounced };

//# sourceMappingURL=useStateDebounced.js.map